export async function dynamicResolveHost<T>(
  callback: (
    resolveHost: (typeof import('@loc/hosts/src/helpers.server'))['resolveHost'],
  ) => T,
) {
  const resolveHost = (await import('@loc/hosts/src/helpers.server'))
    .resolveHost
  return await callback(resolveHost)
}
